/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemTocart = function(pid) {
    return new Promise((resolve, reject) => {
        fetch('/cart/add.js', {
            method: 'POST',
            data: JSON.stringify({
                items: [
                    {
                        id: pid,
                        quantity: 1
                    }
                ]
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((line_item) => {
            ShopifyAPI.onItemAdded(line_item);
            resolve();
        }).catch((err) => {
            console.error(err);
            reject();
        });
    })
}

ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);

    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
        BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
        BOLD.common.eventEmitter.emit('BOLD_COMMON_redirect_upsell_product');
    }
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

var globaleflowVariantInfo = '';
// flow.io code commented
// Track flowJS Variants
// let flowVariantInfo = '';
// if(typeof Flow !== 'undefined'){
//     Flow.set('on', 'ready', function () {
//         if(Flow.getExperience()) {
//             console.log('get Flow variants')
    
//             //make sure we are in a Flow experience and grab all the variant ids from the Shopify variant selector element
//             const selectorOptions = Array.from(document.querySelectorAll('[name="id"] option[data-sku]'));
        
//             //get all variants of the product into an array
//             const idArray = selectorOptions.map((option) => option.value);
        
//             const variantOptions = {
//               variants: idArray, // List of variant ids to load
//               experience: window.Flow.getExperience(), // Limits results by Flow experience key
//               success: (status, variants) => {
//                 console.log("👇🏻 Variants in Flow Cache 👇🏻");
//                 console.log(variants)
//                 flowVariantInfo = variants;
//               },
//               error: (status, error) => console.log(status, error), // Error callback
//             };
        
//             //load variants into Flow cache
//             if(selectorOptions.length > 0) {
//                 Flow.variants.load(variantOptions);
//             }
//         }
//     });
// }

/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    var disabledCTAClass = 'disabled';
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPriceBox = $productWrapper.find('.price-box'),
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $installmentsReferencePrice = $productWrapper.find('.product-reference-price-for-installments'),
        $addToCartText = $productWrapper.find('.add-to-cart-text'),
        $membershipAdd = $productWrapper.find('.membership-add');

    // Variant
    console.log('variant:',variant);
    globaleflowVariantInfo = variant;
    // console.log('flowVariantInfo:',flowVariantInfo);

    if (variant) {
        $('#AddToCartForm').attr('selected-variant', variant.id);
        // Select a valid variant if available
        if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass(`${disabledCTAClass} sold-out`);//.prop('disabled', false);
            $membershipAdd.text( $membershipAdd.data('cta') ).removeClass(disabledCTAClass);
            if ($addToCart.hasClass('pre-order')) {
                $addToCartText.html("Pre Order");
            } else {
                $addToCartText.html("Add to Cart");
            }
        } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $addToCart.addClass(`${disabledCTAClass} sold-out`);//.prop('disabled', true);
            $membershipAdd.text('Sold Out').addClass(disabledCTAClass);
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sold Out");
            }
        }
        
        // Regardless of stock, update the product price
        // console.log('variant.price', variant.price );
        if(!$productPriceBox.hasClass('not-domestic')){
            $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
            $installmentsReferencePrice.html(Shopify.formatMoney(variant.price, moneyFormat));

            let sezzleHTML = $(document).find('.sezzle-button-text').html();
            
            if(typeof sezzleHTML !== "undefined"){
                sezzleHTML = sezzleHTML.replace('starting at','of');
                $(document).find('.sezzle-button-text').html( sezzleHTML );
            }

            $productPrice.attr('content',variant.price ).addClass('updated');
            // Also update and show the product's compare price if necessary
            if (variant.compare_at_price > variant.price) {
                $comparePrice = $productWrapper.find('.product-compare-price');
                $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
            } else {
                $comparePrice.hide();
            }
        }else{
            // flow.io code commented
            // Get localized prices
            // if(typeof flowVariantInfo[ variant.id ] !== 'undefined' && flowVariantInfo != ''){
            //     $productPrice.html( flowVariantInfo[ variant.id ].prices.item.label );
            //     $installmentsReferencePrice.html( flowVariantInfo[ variant.id ].prices.item.label );

            //     let sezzleHTML = $(document).find('.sezzle-button-text').html();
                
            //     if(typeof sezzleHTML !== "undefined"){
            //         sezzleHTML = sezzleHTML.replace('starting at','of');
            //         $(document).find('.sezzle-button-text').html( sezzleHTML );
            //     }

            //     $productPrice.attr('content',variant.price ).addClass('updated');

            //     if(typeof flowVariantInfo[ variant.id ].prices.compare_at !== 'undefined'){
            //         $comparePrice = $productWrapper.find('.product-compare-price');
            //         $comparePrice.html( flowVariantInfo[ variant.id ].prices.compare_at.label ).show();
            //     } else {
            //         $comparePrice.html('').hide();
            //     }
            // }
            if(!variant.available){
                $addToCart.addClass('');
                $addToCartText.html("Sold out");
            }
        }

    } else {
        // console.log('variant is false, should disable the button, not show sold out');
        $addToCart.addClass(disabledCTAClass);//.prop('disabled', true);
        $membershipAdd.text(`Choose ${ $('#AddToCart').data('variant-title') }`).addClass(disabledCTAClass);
        if (!$addToCart.hasClass('inquire') && !$addToCart.hasClass('sold-out') ) {
            $addToCartText.html("Choose ");
        }
    }

    $addToCart.removeClass('loading');
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            var proceed = true;
            var $currForm = $(evt.target);
            var $selects = $currForm.find('select');
            $.each($selects, function(i, v) {
                if ($(v).val() == '') {
                    proceed = false;
                    return false;
                }
            });

            if (!proceed) {
                // console.log('Please choose a product variant selection');
                var skuOffset = $formContainer.offset().top - $('.site-header').height() - 100;
                    $("html, body").animate({scrollTop:skuOffset},400);
                return false;
            }

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function(selectedItemId) {
        console.log('ITEM ADDED CALLBACK')
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart, selectedItemId);

            const itemAddedEvent = new Event('afterAddToCart.ajaxCart', cart);

            document.body.dispatchEvent(itemAddedEvent);
        });
    };

    window._itemAddedCallback = itemAddedCallback;

    itemErrorCallback = function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
            }
        }
    };

    cartUpdateCallback = function(cart, selectedItemId) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart, selectedItemId);
    };

    /**
     * buildCart.
     *
     * @param {Object} cart - Cart object
     * @param {number} selectedItemId - Overrides logic to only show item from variant dropdown
     */
    buildCart = function(cart, selectedItemId) {
        console.log('BUILD CART ', selectedItemId);

        /**
         * getUrlVars.
         */
        var getUrlVars = function(){
            var vars = [], hash;
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++){
                hash = hashes[i].split('=');
                vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        };

        var $productWrapper = $('.product-core'), // Defined the Product Dom Scope
            $productPrice = $productWrapper.find('.product-price'),
            $installmentsReferencePrice = $productWrapper.find('.product-reference-price-for-installments'),
            $comparePrice = $productWrapper.find('.product-compare-price'),
            $productPriceBox = $productWrapper.find('.price-box');

        // Grab Current selected variant price
        var $selectedVariantPrice = '';
        // if($productWrapper.find('.price-box').hasClass('has-special')){
            // console.log('apply discount via bold');
            // if($productWrapper.find('.price-box').hasClass('has-discount')){
            //     $selectedVariantPrice = $productWrapper.find('.product-list-price').text();
            // }else{
            //     $selectedVariantPrice = $productWrapper.find('.product-price.money').text();
            // }
            $selectedVariantPrice = $productWrapper.find('.product-real-price').text();
            $selectedVariantPrice = parseFloat( $selectedVariantPrice.replace(/[^0-9]+/g,"") );
        // }
        console.log('$selectedVariantPrice', $selectedVariantPrice);

        // Bold:PRE
        if (typeof window.BOLD !== 'undefined'
        && typeof window.BOLD.common !== 'undefined'
        && typeof window.BOLD.common.cartDoctor !== 'undefined') {
            // console.log('cart with BOLD');
            // NOTE: "cart" should be the variable containing the cart JSON data
            cart = window.BOLD.common.cartDoctor.fix(cart);
        }
        // Bold:PRE

        // Check if product has QS variant and Bold Pricing
        let queryString = getUrlVars();
        let selectedVariantID;
        if (queryString) {
            $.each(queryString, function(i,e){
                if(queryString[i] == 'variant' && queryString[queryString[i]] != ''){
                    selectedVariantID = parseFloat(queryString[queryString[i]]);
                }
            });
        }

        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p class="ajaxcart__empty">' + "Your bag is currently empty." + '</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            var variantPrice = cartItem.price;
            var variantCurrency = false;
            var variantLinePrice = cartItem.line_price;
            var variantOriginalLinePrice = cartItem.original_line_price;
            var variantPriceTotal = cartItem.price * cartItem.quantity;
            var variantDiscountApplied = cartItem.line_price === cartItem.original_line_price ? false : true;
            var currencySymbol = '';

            if (selectedVariantID == cartItem.id && $selectedVariantPrice != '') {
                variantPrice = $selectedVariantPrice;
                variantLinePrice =  $selectedVariantPrice * cartItem.quantity;
                variantOriginalLinePrice = $selectedVariantPrice * cartItem.quantity;

                // Convert prices format before sending them to the template
                variantPrice = Shopify.formatMoney( variantPrice, settings.moneyFormat);
                variantLinePrice = Shopify.formatMoney( variantLinePrice, settings.moneyFormat );
                variantOriginalLinePrice = Shopify.formatMoney( variantOriginalLinePrice, settings.moneyFormat );
            }
  
            console.log('settings.moneyFormat', settings.moneyFormat);
            console.log('cartItem.id', cartItem.id);
            console.log('selectedVariantID', selectedVariantID);
            console.log('$selectedVariantPrice', $selectedVariantPrice);
            console.log('variantPrice', variantPrice);
            console.log('variantLinePrice', variantLinePrice);
            console.log('variantOriginalLinePrice', variantOriginalLinePrice);

            console.log('cartItem.price', cartItem.price);
            console.log('cartItem.line_price', cartItem.line_price);
            console.log('cartItem.originalLinePrice', cartItem.original_line_price);
            // console.log('flowVariantInfo:', flowVariantInfo);
            variantCurrency = GLBE_PARAMS.currencyCode;
            if(globaleflowVariantInfo != '' && globaleflowVariantInfo.compare_at_price != null){
                if(variantCurrency != 'USD'){
                    variantOriginalLinePrice = Shopify.formatMoney(globaleflowVariantInfo.compare_at_price * cartItem.quantity, settings.moneyFormat)
                }
            }else{
                variantOriginalLinePrice = '';
            }
            // flow.io code commented
            // Check for if experience is domestic or not
            // if(flowVariantInfo != '' && typeof flowVariantInfo[cartItem.id] !== 'undefined'){
            //     console.log( 'flowVariantInfo[cartItem.id]', flowVariantInfo[cartItem.id] );

            //     var currentFlowSessionDetails = Flow.session.getSession();
            //         currencySymbol = currentFlowSessionDetails.local.currency.symbols.primary;

            //     if(flowVariantInfo[cartItem.id].prices.item.currency != 'USD'){
            //         // Re assign price variables
            //         console.log( 'price', flowVariantInfo[cartItem.id].prices.item.label );
            //         variantPrice = flowVariantInfo[cartItem.id].prices.item.label;
            //         variantCurrency = flowVariantInfo[cartItem.id].prices.item.currency;
            //         variantLinePrice = variantPrice; //flowVariantInfo[cartItem.id].prices.item.cents * cartItem.quantity;
            //         variantDiscountApplied = false;
            //         if( typeof flowVariantInfo[cartItem.id].prices.compare_at !== 'undefined' ){
            //             console.log( 'compare price', flowVariantInfo[cartItem.id].prices.compare_at.amount );
            //             variantOriginalLinePrice = flowVariantInfo[cartItem.id].prices.compare_at.label;
            //             variantDiscountApplied = true;
            //         }

            //     }
            // }
            
            let itemMiniCartShow = 'item-hide';
            // We only show the item that was just added to the cart, and
            // hide all other line items currently present in the cart.
            // If the variant chosen in the dropdown does not match the item
            // in the cart, it is not shown
            if (!selectedVariantID || selectedVariantID == cartItem.id){
                itemMiniCartShow = 'item-display';
            }
            console.log('currencySymbol:', currencySymbol);
            console.log('variantPrice:', variantPrice);
            console.log('variantOriginalLinePrice:', variantOriginalLinePrice);
            console.log('variantCurrency:', variantCurrency);
            console.log('variantDiscountApplied:', variantDiscountApplied);

            // pricing Fallback
            variantPrice = typeof variantPrice !== 'undefined' ? variantPrice : Shopify.formatMoney( cartItem.price, settings.moneyFormat );
            variantLinePrice =  typeof variantLinePrice !== 'undefined' ? variantLinePrice : Shopify.formatMoney( cartItem.line_price, settings.moneyFormat );
            variantOriginalLinePrice = typeof variantOriginalLinePrice !== 'undefined' ? variantOriginalLinePrice : Shopify.formatMoney( cartItem.original_line_price, settings.moneyFormat );

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                options_with_values: cartItem.options_with_values,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: variantPrice,
                vendor: cartItem.vendor,
                linePrice: variantLinePrice,
                originalLinePrice: variantOriginalLinePrice,
                discounts: cartItem.discounts,
                discountsApplied: variantDiscountApplied,
                isGiftCard: cartItem.gift_card,
                itemMiniCartShow: itemMiniCartShow
            };

            if(variantCurrency !== 'USD'){
                item.currency = variantCurrency
            }

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            item_count: items.length,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }
        console.log('ITEM DATA ', data)

        $cartContainer.append(template(data));

        cartCallback(cart);
    };

    window._buildCart = buildCart;

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line');

            if (isUpdating) {
                return;
            }
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // flow.io code commented
        // if(typeof Flow !== undefined){
        //     console.log('Flow cart localize');
        //     Flow.cart.localize();
        // }

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');

        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', async function(e) {
                e.preventDefault();
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);

                const formData = $el.parents('form').serialize();
                const currentURL = window.location.href;
                try {
                    const { status } = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        },
                        body: formData
                    });

                    if (!(status >= 200 && status < 300)) return alert('There was an error updating this item, please try again');

                    $el.parent().children().prop('disabled', true);
                    window.location.href = currentURL;
                } catch (err) {
                    console.error(err);
                }
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
